export interface Price {
  /** The value to format. */
  amount: number;
}

export interface FormatPriceSettings {
  /** The locale to use for formatting */
  locale: Culture;
}

const formatPrice = ({ amount }: Price, { locale }: FormatPriceSettings) => {
  const isWholeNumber = amount % 1 === 0;

  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    minimumFractionDigits: isWholeNumber ? 0 : 2,
  }).format(amount);
};

export default formatPrice;
